import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AssetConnection = {
  __typename?: 'AssetConnection';
  edges?: Maybe<Array<Maybe<AssetEdge>>>;
  /** The total count of all queryable assets for this schema listing */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AssetEdge = {
  __typename?: 'AssetEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Asset_Tree>;
};

export type AssetInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<InputMaybe<MetadataItem>>>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<ElementTag>>>;
};

export type BaseArticleConnection = {
  __typename?: 'BaseArticleConnection';
  edges?: Maybe<Array<Maybe<BaseArticleEdge>>>;
  /** The total count of all queryable objects for this schema listing */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BaseArticleEdge = {
  __typename?: 'BaseArticleEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Object_BaseArticle>;
};

export type CreateMinilienResult = {
  __typename?: 'CreateMinilienResult';
  message?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Object_Minilien>;
  success?: Maybe<Scalars['Boolean']['output']>;
};


export type CreateMinilienResultOutputArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateObjectFolderResult = {
  __typename?: 'CreateObjectFolderResult';
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOuvrageResult = {
  __typename?: 'CreateOuvrageResult';
  message?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Object_Ouvrage>;
  success?: Maybe<Scalars['Boolean']['output']>;
};


export type CreateOuvrageResultOutputArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePageAtterrissageResult = {
  __typename?: 'CreatePageAtterrissageResult';
  message?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Object_PageAtterrissage>;
  success?: Maybe<Scalars['Boolean']['output']>;
};


export type CreatePageAtterrissageResultOutputArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRessourceNumeriqueResult = {
  __typename?: 'CreateRessourceNumeriqueResult';
  message?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Object_RessourceNumerique>;
  success?: Maybe<Scalars['Boolean']['output']>;
};


export type CreateRessourceNumeriqueResultOutputArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteMinilienResult = {
  __typename?: 'DeleteMinilienResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteOuvrageResult = {
  __typename?: 'DeleteOuvrageResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePageAtterrissageResult = {
  __typename?: 'DeletePageAtterrissageResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRessourceNumeriqueResult = {
  __typename?: 'DeleteRessourceNumeriqueResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** type can be omitted for mutations only allowing one type, e.g. many-to-many-objects. */
export type ElementDescriptorInput = {
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Array<InputMaybe<Element_Metadata_Item_6a746ff10a3a4>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ElementProperty = Property_Asset | Property_Assetfolder | Property_Checkbox | Property_Object | Property_Objectfolder | Property_Select | Property_Text;

export type ElementTag = {
  id?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type FormatConnection = {
  __typename?: 'FormatConnection';
  edges?: Maybe<Array<Maybe<FormatEdge>>>;
  /** The total count of all queryable objects for this schema listing */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FormatEdge = {
  __typename?: 'FormatEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Object_Format>;
};

export type IntervenantConnection = {
  __typename?: 'IntervenantConnection';
  edges?: Maybe<Array<Maybe<IntervenantEdge>>>;
  /** The total count of all queryable objects for this schema listing */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IntervenantEdge = {
  __typename?: 'IntervenantEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Object_Intervenant>;
};

export type MetadataItem = {
  data?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type MinilienConnection = {
  __typename?: 'MinilienConnection';
  edges?: Maybe<Array<Maybe<MinilienEdge>>>;
  /** The total count of all queryable objects for this schema listing */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MinilienEdge = {
  __typename?: 'MinilienEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Object_Minilien>;
};

export type Mutations = {
  __typename?: 'Mutations';
  createMinilien?: Maybe<CreateMinilienResult>;
  createObjectFolder?: Maybe<CreateObjectFolderResult>;
  createOuvrage?: Maybe<CreateOuvrageResult>;
  createPageAtterrissage?: Maybe<CreatePageAtterrissageResult>;
  createRessourceNumerique?: Maybe<CreateRessourceNumeriqueResult>;
  deleteMinilien?: Maybe<DeleteMinilienResult>;
  deleteOuvrage?: Maybe<DeleteOuvrageResult>;
  deletePageAtterrissage?: Maybe<DeletePageAtterrissageResult>;
  deleteRessourceNumerique?: Maybe<DeleteRessourceNumeriqueResult>;
  updateAsset?: Maybe<UpdateAssetResult>;
  updateAssetFolder?: Maybe<UpdateAssetFolderResult>;
  updateMinilien?: Maybe<UpdateMinilienResult>;
  updateObjectFolder?: Maybe<UpdateObjectFolderResult>;
  updateOuvrage?: Maybe<UpdateOuvrageResult>;
  updatePageAtterrissage?: Maybe<UpdatePageAtterrissageResult>;
  updateRessourceNumerique?: Maybe<UpdateRessourceNumeriqueResult>;
};


export type MutationsCreateMinilienArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<UpdateMinilienInput>;
  key: Scalars['String']['input'];
  omitMandatoryCheck?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsCreateObjectFolderArgs = {
  key: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsCreateOuvrageArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<UpdateOuvrageInput>;
  key: Scalars['String']['input'];
  omitMandatoryCheck?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsCreatePageAtterrissageArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<UpdatePageAtterrissageInput>;
  key: Scalars['String']['input'];
  omitMandatoryCheck?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsCreateRessourceNumeriqueArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<UpdateRessourceNumeriqueInput>;
  key: Scalars['String']['input'];
  omitMandatoryCheck?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsDeleteMinilienArgs = {
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsDeleteOuvrageArgs = {
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsDeletePageAtterrissageArgs = {
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsDeleteRessourceNumeriqueArgs = {
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpdateAssetArgs = {
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<AssetInput>;
  omitVersionCreate?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpdateAssetFolderArgs = {
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UpdateAssetFolderInput>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpdateMinilienArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UpdateMinilienInput>;
  omitMandatoryCheck?: InputMaybe<Scalars['Boolean']['input']>;
  omitVersionCreate?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpdateObjectFolderArgs = {
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UpdateObjectFolderInput>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpdateOuvrageArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UpdateOuvrageInput>;
  omitMandatoryCheck?: InputMaybe<Scalars['Boolean']['input']>;
  omitVersionCreate?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpdatePageAtterrissageArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UpdatePageAtterrissageInput>;
  omitMandatoryCheck?: InputMaybe<Scalars['Boolean']['input']>;
  omitVersionCreate?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpdateRessourceNumeriqueArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UpdateRessourceNumeriqueInput>;
  omitMandatoryCheck?: InputMaybe<Scalars['Boolean']['input']>;
  omitVersionCreate?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type OuvrageConnection = {
  __typename?: 'OuvrageConnection';
  edges?: Maybe<Array<Maybe<OuvrageEdge>>>;
  /** The total count of all queryable objects for this schema listing */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OuvrageEdge = {
  __typename?: 'OuvrageEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Object_Ouvrage>;
};

export type PageAtterrissageConnection = {
  __typename?: 'PageAtterrissageConnection';
  edges?: Maybe<Array<Maybe<PageAtterrissageEdge>>>;
  /** The total count of all queryable objects for this schema listing */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PageAtterrissageEdge = {
  __typename?: 'PageAtterrissageEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Object_PageAtterrissage>;
};

export type Query = {
  __typename?: 'Query';
  getAsset?: Maybe<Asset>;
  getAssetFolder?: Maybe<Asset_Folder>;
  getAssetListing?: Maybe<AssetConnection>;
  getBaseArticle?: Maybe<Object_BaseArticle>;
  getBaseArticleListing?: Maybe<BaseArticleConnection>;
  getFormat?: Maybe<Object_Format>;
  getFormatListing?: Maybe<FormatConnection>;
  getIntervenant?: Maybe<Object_Intervenant>;
  getIntervenantListing?: Maybe<IntervenantConnection>;
  getMinilien?: Maybe<Object_Minilien>;
  getMinilienListing?: Maybe<MinilienConnection>;
  getObjectFolder?: Maybe<Object_Folder>;
  getOuvrage?: Maybe<Object_Ouvrage>;
  getOuvrageListing?: Maybe<OuvrageConnection>;
  getPageAtterrissage?: Maybe<Object_PageAtterrissage>;
  getPageAtterrissageListing?: Maybe<PageAtterrissageConnection>;
  getRessourceNumerique?: Maybe<Object_RessourceNumerique>;
  getRessourceNumeriqueListing?: Maybe<RessourceNumeriqueConnection>;
  getUser?: Maybe<Object_User>;
  getUserListing?: Maybe<UserConnection>;
};


export type QueryGetAssetArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAssetFolderArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAssetListingArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullpaths?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  joins?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetBaseArticleArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetBaseArticleListingArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullpaths?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  joins?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFormatArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFormatListingArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullpaths?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  joins?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetIntervenantArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetIntervenantListingArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullpaths?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  joins?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMinilienArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMinilienListingArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullpaths?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  joins?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetObjectFolderArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetOuvrageArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetOuvrageListingArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullpaths?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  joins?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPageAtterrissageArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPageAtterrissageListingArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullpaths?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  joins?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRessourceNumeriqueArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRessourceNumeriqueListingArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullpaths?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  joins?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  fullpath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUserListingArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullpaths?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  joins?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

export type RessourceNumeriqueConnection = {
  __typename?: 'RessourceNumeriqueConnection';
  edges?: Maybe<Array<Maybe<RessourceNumeriqueEdge>>>;
  /** The total count of all queryable objects for this schema listing */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RessourceNumeriqueEdge = {
  __typename?: 'RessourceNumeriqueEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Object_RessourceNumerique>;
};

export type UpdateAssetFolderInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAssetFolderResult = {
  __typename?: 'UpdateAssetFolderResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAssetResult = {
  __typename?: 'UpdateAssetResult';
  assetData?: Maybe<Asset>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};


export type UpdateAssetResultAssetDataArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMinilienInput = {
  tags?: InputMaybe<Array<InputMaybe<ElementTag>>>;
  url_courte?: InputMaybe<Scalars['String']['input']>;
  url_longue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMinilienResult = {
  __typename?: 'UpdateMinilienResult';
  message?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Object_Minilien>;
  success?: Maybe<Scalars['Boolean']['output']>;
};


export type UpdateMinilienResultOutputArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateObjectFolderInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateObjectFolderResult = {
  __typename?: 'UpdateObjectFolderResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateOuvrageInput = {
  CodeProjet?: InputMaybe<Scalars['String']['input']>;
  is_reprise?: InputMaybe<Scalars['Boolean']['input']>;
  statut?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<ElementTag>>>;
};

export type UpdateOuvrageResult = {
  __typename?: 'UpdateOuvrageResult';
  message?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Object_Ouvrage>;
  success?: Maybe<Scalars['Boolean']['output']>;
};


export type UpdateOuvrageResultOutputArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageAtterrissageInput = {
  actif?: InputMaybe<Scalars['Boolean']['input']>;
  idPage?: InputMaybe<Scalars['String']['input']>;
  numeroFolio?: InputMaybe<Scalars['Float']['input']>;
  ouvrage?: InputMaybe<ElementDescriptorInput>;
  tags?: InputMaybe<Array<InputMaybe<ElementTag>>>;
  tauxRemplissage?: InputMaybe<Scalars['Float']['input']>;
  titre?: InputMaybe<Scalars['String']['input']>;
  verouille?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageAtterrissageResult = {
  __typename?: 'UpdatePageAtterrissageResult';
  message?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Object_PageAtterrissage>;
  success?: Maybe<Scalars['Boolean']['output']>;
};


export type UpdatePageAtterrissageResultOutputArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRessourceNumeriqueInput = {
  Lib?: InputMaybe<Scalars['Boolean']['input']>;
  LibImpression?: InputMaybe<Scalars['Boolean']['input']>;
  LibModification?: InputMaybe<Scalars['Boolean']['input']>;
  LibTelechargement?: InputMaybe<Scalars['Boolean']['input']>;
  Max?: InputMaybe<Scalars['Boolean']['input']>;
  OGRNPlay?: InputMaybe<Scalars['Boolean']['input']>;
  categorie?: InputMaybe<Scalars['String']['input']>;
  cible?: InputMaybe<Scalars['String']['input']>;
  commentaires?: InputMaybe<Scalars['String']['input']>;
  debutVideo?: InputMaybe<Scalars['Float']['input']>;
  finVideo?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<ElementDescriptorInput>;
  idAstra?: InputMaybe<Scalars['String']['input']>;
  libelleAction?: InputMaybe<Scalars['String']['input']>;
  lien?: InputMaybe<Scalars['String']['input']>;
  minilienEdubelin?: InputMaybe<Scalars['Boolean']['input']>;
  misEnAvant?: InputMaybe<Scalars['Boolean']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
  numeroFolio?: InputMaybe<Scalars['String']['input']>;
  ordre?: InputMaybe<Scalars['Float']['input']>;
  ouvrage?: InputMaybe<ElementDescriptorInput>;
  pageAtterrissage?: InputMaybe<Array<InputMaybe<ElementDescriptorInput>>>;
  structure?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<ElementTag>>>;
  tauxRemplissage?: InputMaybe<Scalars['Float']['input']>;
  titreEditeur?: InputMaybe<Scalars['String']['input']>;
  titreGrain?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  verouille?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRessourceNumeriqueResult = {
  __typename?: 'UpdateRessourceNumeriqueResult';
  message?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Object_RessourceNumerique>;
  success?: Maybe<Scalars['Boolean']['output']>;
};


export type UpdateRessourceNumeriqueResultOutputArgs = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** The total count of all queryable objects for this schema listing */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Object_User>;
};

export type Asset = Element & {
  __typename?: 'asset';
  _siblings?: Maybe<Array<Maybe<Asset_Tree>>>;
  children?: Maybe<Array<Maybe<Asset_Tree>>>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<Dimensions>;
  duration?: Maybe<Scalars['Float']['output']>;
  embeddedMetaInfo?: Maybe<Array<Maybe<Asset_EmbeddedMetaInfo_Item>>>;
  filename?: Maybe<Scalars['String']['output']>;
  filesize?: Maybe<Scalars['Int']['output']>;
  fullpath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Array<Maybe<Asset_Metadata_Item>>>;
  mimetype?: Maybe<Scalars['String']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<Asset_Tree>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
  resolutions?: Maybe<Array<Maybe<Resolutions>>>;
  srcset?: Maybe<Array<Maybe<Srcset>>>;
  tags?: Maybe<Array<Maybe<Element_Tag>>>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type AssetDataArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};


export type AssetDimensionsArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};


export type AssetFullpathArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};


export type AssetMetadataArgs = {
  ignore_language?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type AssetPropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AssetResolutionsArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  thumbnail: Scalars['String']['input'];
  types?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type AssetSrcsetArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  thumbnail: Scalars['String']['input'];
};


export type AssetTagsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Asset_EmbeddedMetaInfo_Item = {
  __typename?: 'asset_embeddedMetaInfo_item';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Asset_Folder = {
  __typename?: 'asset_folder';
  _siblings?: Maybe<Array<Maybe<Asset_Tree>>>;
  children?: Maybe<Array<Maybe<Asset_Tree>>>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  fullpath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<Asset_Folder>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
};


export type Asset_FolderFullpathArgs = {
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};


export type Asset_FolderPropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Asset_Metadata_Item = {
  __typename?: 'asset_metadata_item';
  data?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Asset_Tree = Asset | Asset_Folder;

export type Dimensions = {
  __typename?: 'dimensions';
  height?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type Element = {
  id?: Maybe<Scalars['ID']['output']>;
};

export type Element_Metadata_Item_6a746ff10a3a4 = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Element_Metadata_Item_6a746ff10a95a = {
  __typename?: 'element_metadata_item_6a746ff10a95a';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Element_Metadata_Item_6a746ff10a998 = {
  __typename?: 'element_metadata_item_6a746ff10a998';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Element_Tag = {
  __typename?: 'element_tag';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type Hotspot_Metadata_Object = Asset | Asset_Folder | Object_BaseArticle | Object_Format | Object_Intervenant | Object_Minilien | Object_Ouvrage | Object_PageAtterrissage | Object_RessourceNumerique | Object_User;

export type Object_BaseArticle = Element & {
  __typename?: 'object_BaseArticle';
  AssistantEdito?: Maybe<Scalars['String']['output']>;
  Classe?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CodeArticle?: Maybe<Scalars['String']['output']>;
  CodeOeuvre?: Maybe<Scalars['String']['output']>;
  Collection?: Maybe<Array<Maybe<Object_BaseArticle_Collection>>>;
  CollectionEdito_search?: Maybe<Scalars['String']['output']>;
  DateParution?: Maybe<Scalars['String']['output']>;
  EAN?: Maybe<Scalars['String']['output']>;
  Editeur?: Maybe<Array<Maybe<Object_BaseArticle_Editeur>>>;
  EditeurInterne?: Maybe<Scalars['String']['output']>;
  GroupeOeuvre?: Maybe<Scalars['String']['output']>;
  LienEdulib?: Maybe<Scalars['String']['output']>;
  LienExterne?: Maybe<Scalars['String']['output']>;
  MaisonMarque?: Maybe<Scalars['String']['output']>;
  Matieres?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Niveau?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  NomCollection?: Maybe<Scalars['String']['output']>;
  Publiable?: Maybe<Scalars['Boolean']['output']>;
  StatutArticle?: Maybe<Scalars['String']['output']>;
  Support?: Maybe<Scalars['String']['output']>;
  ThematiquesJeunesse?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TitreWEB?: Maybe<Scalars['String']['output']>;
  _siblings?: Maybe<Array<Maybe<Object_Tree>>>;
  children?: Maybe<Array<Maybe<Object_Tree>>>;
  childrenSortBy?: Maybe<Scalars['String']['output']>;
  classname?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  ouvrage?: Maybe<Array<Maybe<Object_Ouvrage>>>;
  parent?: Maybe<Object_Tree>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
  synchroId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Element_Tag>>>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type Object_BaseArticle_SiblingsArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_BaseArticleChildrenArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_BaseArticlePropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_BaseArticleTagsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Object_BaseArticle_Collection = {
  __typename?: 'object_BaseArticle_Collection';
  element?: Maybe<Object_Collection>;
  metadata?: Maybe<Array<Maybe<Element_Metadata_Item_6a746ff10a95a>>>;
};

export type Object_BaseArticle_Editeur = {
  __typename?: 'object_BaseArticle_Editeur';
  element?: Maybe<Object_Editeurs>;
  metadata?: Maybe<Array<Maybe<Element_Metadata_Item_6a746ff10a998>>>;
};

export type Object_Collection = Element & {
  __typename?: 'object_Collection';
  _siblings?: Maybe<Array<Maybe<Object_Tree>>>;
  children?: Maybe<Array<Maybe<Object_Tree>>>;
  childrenSortBy?: Maybe<Scalars['String']['output']>;
  classname?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Object_Tree>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
  tags?: Maybe<Array<Maybe<Element_Tag>>>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type Object_Collection_SiblingsArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_CollectionChildrenArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_CollectionPropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_CollectionTagsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Object_Editeurs = Element & {
  __typename?: 'object_Editeurs';
  _siblings?: Maybe<Array<Maybe<Object_Tree>>>;
  children?: Maybe<Array<Maybe<Object_Tree>>>;
  childrenSortBy?: Maybe<Scalars['String']['output']>;
  classname?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Object_Tree>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
  tags?: Maybe<Array<Maybe<Element_Tag>>>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type Object_Editeurs_SiblingsArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_EditeursChildrenArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_EditeursPropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_EditeursTagsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Object_Format = Element & {
  __typename?: 'object_Format';
  _siblings?: Maybe<Array<Maybe<Object_Tree>>>;
  children?: Maybe<Array<Maybe<Object_Tree>>>;
  childrenSortBy?: Maybe<Scalars['String']['output']>;
  classname?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Object_Tree>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
  tags?: Maybe<Array<Maybe<Element_Tag>>>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type Object_Format_SiblingsArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_FormatChildrenArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_FormatPropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_FormatTagsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Object_Intervenant = Element & {
  __typename?: 'object_Intervenant';
  EditeurInterne?: Maybe<Scalars['Boolean']['output']>;
  _siblings?: Maybe<Array<Maybe<Object_Tree>>>;
  actif?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<Maybe<Object_Tree>>>;
  childrenSortBy?: Maybe<Scalars['String']['output']>;
  classname?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Object_Tree>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
  synchroId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Element_Tag>>>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type Object_Intervenant_SiblingsArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_IntervenantChildrenArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_IntervenantPropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_IntervenantTagsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Object_Minilien = Element & {
  __typename?: 'object_Minilien';
  TitreWeb?: Maybe<Scalars['String']['output']>;
  _siblings?: Maybe<Array<Maybe<Object_Tree>>>;
  children?: Maybe<Array<Maybe<Object_Tree>>>;
  childrenSortBy?: Maybe<Scalars['String']['output']>;
  classname?: Maybe<Scalars['String']['output']>;
  codeArticle?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  idPage?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Object_Minilien_Page>;
  parent?: Maybe<Object_Tree>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
  ressourceNumerique?: Maybe<Object_Minilien_RessourceNumerique>;
  sansProjet?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Maybe<Element_Tag>>>;
  type_minilien?: Maybe<Scalars['String']['output']>;
  url_courte?: Maybe<Scalars['String']['output']>;
  url_longue?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type Object_Minilien_SiblingsArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_MinilienChildrenArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_MinilienPropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_MinilienTagsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** pseudo class for field page */
export type Object_Minilien_Page = Object_PageAtterrissage;

/** pseudo class for field ressourceNumerique */
export type Object_Minilien_RessourceNumerique = Object_RessourceNumerique;

export type Object_Ouvrage = Element & {
  __typename?: 'object_Ouvrage';
  BaseArticle?: Maybe<Object_Ouvrage_BaseArticle>;
  CodeProjet?: Maybe<Scalars['String']['output']>;
  _siblings?: Maybe<Array<Maybe<Object_Tree>>>;
  children?: Maybe<Array<Maybe<Object_Tree>>>;
  childrenSortBy?: Maybe<Scalars['String']['output']>;
  classname?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  is_reprise?: Maybe<Scalars['Boolean']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  ouvrage_reforme?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<Object_Tree>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
  statut?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Element_Tag>>>;
  taux_remplissage_media?: Maybe<Scalars['String']['output']>;
  taux_remplissage_rn?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type Object_Ouvrage_SiblingsArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_OuvrageChildrenArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_OuvragePropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_OuvrageTagsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** pseudo class for field BaseArticle */
export type Object_Ouvrage_BaseArticle = Object_BaseArticle;

export type Object_PageAtterrissage = Element & {
  __typename?: 'object_PageAtterrissage';
  _siblings?: Maybe<Array<Maybe<Object_Tree>>>;
  actif?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<Maybe<Object_Tree>>>;
  childrenSortBy?: Maybe<Scalars['String']['output']>;
  classname?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  idPage?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  miniliens?: Maybe<Array<Maybe<Object_Minilien>>>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  numeroFolio?: Maybe<Scalars['Float']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  ouvrage?: Maybe<Object_PageAtterrissage_Ouvrage>;
  parent?: Maybe<Object_Tree>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
  ressourcesNumeriques?: Maybe<Array<Maybe<Object_RessourceNumerique>>>;
  tags?: Maybe<Array<Maybe<Element_Tag>>>;
  tauxRemplissage?: Maybe<Scalars['Float']['output']>;
  taux_remplissage_media?: Maybe<Scalars['String']['output']>;
  taux_remplissage_rn?: Maybe<Scalars['String']['output']>;
  titre?: Maybe<Scalars['String']['output']>;
  verouille?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type Object_PageAtterrissage_SiblingsArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_PageAtterrissageChildrenArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_PageAtterrissagePropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_PageAtterrissageTagsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** pseudo class for field ouvrage */
export type Object_PageAtterrissage_Ouvrage = Object_Ouvrage;

export type Object_RessourceNumerique = Element & {
  __typename?: 'object_RessourceNumerique';
  Lib?: Maybe<Scalars['Boolean']['output']>;
  LibImpression?: Maybe<Scalars['Boolean']['output']>;
  LibModification?: Maybe<Scalars['Boolean']['output']>;
  LibTelechargement?: Maybe<Scalars['Boolean']['output']>;
  Max?: Maybe<Scalars['Boolean']['output']>;
  OGRNPlay?: Maybe<Scalars['Boolean']['output']>;
  _siblings?: Maybe<Array<Maybe<Object_Tree>>>;
  categorie?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Maybe<Object_Tree>>>;
  childrenSortBy?: Maybe<Scalars['String']['output']>;
  cible?: Maybe<Scalars['String']['output']>;
  classname?: Maybe<Scalars['String']['output']>;
  commentaires?: Maybe<Scalars['String']['output']>;
  completion?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  debutVideo?: Maybe<Scalars['Float']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  finVideo?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Object_RessourceNumerique_Format>;
  id?: Maybe<Scalars['ID']['output']>;
  idAstra?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  libelleAction?: Maybe<Scalars['String']['output']>;
  lien?: Maybe<Scalars['String']['output']>;
  medias?: Maybe<Array<Maybe<Object_RessourceNumerique_Medias>>>;
  minilienEdubelin?: Maybe<Scalars['Boolean']['output']>;
  miniliens?: Maybe<Array<Maybe<Object_Minilien>>>;
  misEnAvant?: Maybe<Scalars['Boolean']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  modificationDateFormatted?: Maybe<Scalars['String']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  numeroFolio?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  ordre?: Maybe<Scalars['Float']['output']>;
  ouvrage?: Maybe<Object_RessourceNumerique_Ouvrage>;
  pageAtterrissage?: Maybe<Array<Maybe<Object_RessourceNumerique_PageAtterrissage>>>;
  pagesIds?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Object_Tree>;
  pearltrees?: Maybe<Scalars['Boolean']['output']>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
  siteBelinEducation?: Maybe<Scalars['Boolean']['output']>;
  structure?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Element_Tag>>>;
  tauxRemplissage?: Maybe<Scalars['Float']['output']>;
  titreEditeur?: Maybe<Scalars['String']['output']>;
  titreGrain?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  verouille?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type Object_RessourceNumerique_SiblingsArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_RessourceNumeriqueChildrenArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_RessourceNumeriquePropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_RessourceNumeriqueTagsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** pseudo class for field format */
export type Object_RessourceNumerique_Format = Object_Format;

export type Object_RessourceNumerique_Medias = Asset;

/** pseudo class for field ouvrage */
export type Object_RessourceNumerique_Ouvrage = Object_Ouvrage;

export type Object_RessourceNumerique_PageAtterrissage = Object_PageAtterrissage;

export type Object_Folder = {
  __typename?: 'object_folder';
  _siblings?: Maybe<Array<Maybe<Object_Tree>>>;
  children?: Maybe<Array<Maybe<Object_Tree>>>;
  childrenSortBy?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  fullpath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<Object_Tree>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
};


export type Object_Folder_SiblingsArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_FolderChildrenArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_FolderPropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Object_Tree = Object_BaseArticle | Object_Format | Object_Intervenant | Object_Minilien | Object_Ouvrage | Object_PageAtterrissage | Object_RessourceNumerique | Object_Folder | Object_User;

export type Object_User = Element & {
  __typename?: 'object_user';
  _siblings?: Maybe<Array<Maybe<Object_Tree>>>;
  children?: Maybe<Array<Maybe<Object_Tree>>>;
  childrenSortBy?: Maybe<Scalars['String']['output']>;
  classname?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  modificationDate?: Maybe<Scalars['Int']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Object_Tree>;
  properties?: Maybe<Array<Maybe<ElementProperty>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Element_Tag>>>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type Object_User_SiblingsArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_UserChildrenArgs = {
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_UserPropertiesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Object_UserTagsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Property_Asset = {
  __typename?: 'property_asset';
  asset?: Maybe<Asset>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Property_Assetfolder = {
  __typename?: 'property_assetfolder';
  asset?: Maybe<Asset_Folder>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Property_Checkbox = {
  __typename?: 'property_checkbox';
  checked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Property_Object = {
  __typename?: 'property_object';
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Hotspot_Metadata_Object>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Property_Objectfolder = {
  __typename?: 'property_objectfolder';
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Object_Folder>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Property_Select = {
  __typename?: 'property_select';
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Property_Text = {
  __typename?: 'property_text';
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Resolutions = {
  __typename?: 'resolutions';
  resolution?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Srcset = {
  __typename?: 'srcset';
  descriptor?: Maybe<Scalars['String']['output']>;
  resolutions?: Maybe<Array<Maybe<Resolutions>>>;
  url?: Maybe<Scalars['String']['output']>;
};


export type SrcsetResolutionsArgs = {
  types?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type CreateMinilienMutationVariables = Exact<{
  key: Scalars['String']['input'];
  input?: InputMaybe<UpdateMinilienInput>;
}>;


export type CreateMinilienMutation = { __typename?: 'Mutations', createMinilien?: { __typename?: 'CreateMinilienResult', success?: boolean | null, output?: { __typename?: 'object_Minilien', modificationDate?: number | null } | null } | null };

export type UpdateMinilienMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UpdateMinilienInput>;
}>;


export type UpdateMinilienMutation = { __typename?: 'Mutations', updateMinilien?: { __typename?: 'UpdateMinilienResult', success?: boolean | null, output?: { __typename?: 'object_Minilien', modificationDate?: number | null } | null } | null };

export type UpdateOuvrageMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UpdateOuvrageInput>;
}>;


export type UpdateOuvrageMutation = { __typename?: 'Mutations', updateOuvrage?: { __typename?: 'UpdateOuvrageResult', success?: boolean | null, output?: { __typename?: 'object_Ouvrage', modificationDate?: number | null } | null } | null };

export type UpdatePageAtterrissageMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UpdatePageAtterrissageInput>;
}>;


export type UpdatePageAtterrissageMutation = { __typename?: 'Mutations', updatePageAtterrissage?: { __typename?: 'UpdatePageAtterrissageResult', success?: boolean | null, message?: string | null, output?: { __typename?: 'object_PageAtterrissage', modificationDate?: number | null } | null } | null };

export type UpdateRessourceNumeriqueMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UpdateRessourceNumeriqueInput>;
}>;


export type UpdateRessourceNumeriqueMutation = { __typename?: 'Mutations', updateRessourceNumerique?: { __typename?: 'UpdateRessourceNumeriqueResult', success?: boolean | null, message?: string | null, output?: { __typename?: 'object_RessourceNumerique', modificationDate?: number | null } | null } | null };

export type GetFormatListingQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFormatListingQuery = { __typename?: 'Query', getFormatListing?: { __typename?: 'FormatConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'FormatEdge', node?: { __typename?: 'object_Format', id?: string | null, nom?: string | null, extension?: string | null } | null } | null> | null } | null };

export type GetBaseArticlesListingQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBaseArticlesListingQuery = { __typename?: 'Query', getBaseArticleListing?: { __typename?: 'BaseArticleConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'BaseArticleEdge', node?: { __typename?: 'object_BaseArticle', id?: string | null, CodeArticle?: string | null, EAN?: string | null, TitreWEB?: string | null, ouvrage?: Array<{ __typename?: 'object_Ouvrage', id?: string | null } | null> | null } | null } | null> | null } | null };

export type GetOuvrageByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOuvrageByIdQuery = { __typename?: 'Query', getOuvrage?: { __typename?: 'object_Ouvrage', CodeProjet?: string | null, statut?: string | null, taux_remplissage_rn?: string | null, taux_remplissage_media?: string | null, ouvrage_reforme?: boolean | null, is_reprise?: boolean | null, BaseArticle?: { __typename?: 'object_BaseArticle', id?: string | null, CodeArticle?: string | null, EAN?: string | null, CodeOeuvre?: string | null, CollectionEdito_search?: string | null, DateParution?: string | null, Matieres?: Array<string | null> | null, Classe?: Array<string | null> | null, Support?: string | null, StatutArticle?: string | null, AssistantEdito?: string | null, EditeurInterne?: string | null, TitreWEB?: string | null } | null } | null };

export type GetIntervenantListingQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetIntervenantListingQuery = { __typename?: 'Query', getIntervenantListing?: { __typename?: 'IntervenantConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'IntervenantEdge', node?: { __typename?: 'object_Intervenant', id?: string | null, code?: string | null, display_name?: string | null } | null } | null> | null } | null };

export type GetMinilienListingQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMinilienListingQuery = { __typename?: 'Query', getMinilienListing?: { __typename?: 'MinilienConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'MinilienEdge', node?: { __typename?: 'object_Minilien', id?: string | null, url_courte?: string | null, url_longue?: string | null, codeArticle?: string | null, idPage?: string | null, TitreWeb?: string | null, type_minilien?: string | null } | null } | null> | null } | null };

export type GetOuvrageListingQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOuvrageListingQuery = { __typename?: 'Query', getOuvrageListing?: { __typename?: 'OuvrageConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'OuvrageEdge', node?: { __typename?: 'object_Ouvrage', id?: string | null, taux_remplissage_rn?: string | null, taux_remplissage_media?: string | null, ouvrage_reforme?: boolean | null, CodeProjet?: string | null, BaseArticle?: { __typename?: 'object_BaseArticle', CodeArticle?: string | null, TitreWEB?: string | null, EAN?: string | null, CodeOeuvre?: string | null, StatutArticle?: string | null, Support?: string | null, CollectionEdito_search?: string | null, DateParution?: string | null, Matieres?: Array<string | null> | null, Classe?: Array<string | null> | null, AssistantEdito?: string | null, EditeurInterne?: string | null } | null } | null } | null> | null } | null };

export type GetPageAtterrissageListingQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPageAtterrissageListingQuery = { __typename?: 'Query', getPageAtterrissageListing?: { __typename?: 'PageAtterrissageConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'PageAtterrissageEdge', node?: { __typename?: 'object_PageAtterrissage', id?: string | null, idPage?: string | null, titre?: string | null, numeroFolio?: number | null, taux_remplissage_rn?: string | null, taux_remplissage_media?: string | null, actif?: boolean | null, verouille?: boolean | null, miniliens?: Array<{ __typename?: 'object_Minilien', url_courte?: string | null, id?: string | null, url_longue?: string | null, type_minilien?: string | null } | null> | null, ressourcesNumeriques?: Array<{ __typename?: 'object_RessourceNumerique', id?: string | null } | null> | null, ouvrage?: { __typename?: 'object_Ouvrage', id?: string | null, CodeProjet?: string | null } | null } | null } | null> | null } | null };

export type GetRessourceNumeriqueListingQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRessourceNumeriqueListingQuery = { __typename?: 'Query', getRessourceNumeriqueListing?: { __typename?: 'RessourceNumeriqueConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'RessourceNumeriqueEdge', node?: { __typename?: 'object_RessourceNumerique', id?: string | null, modificationDateFormatted?: string | null, Lib?: boolean | null, LibImpression?: boolean | null, LibModification?: boolean | null, LibTelechargement?: boolean | null, Max?: boolean | null, OGRNPlay?: boolean | null, categorie?: string | null, cible?: string | null, debutVideo?: number | null, finVideo?: number | null, idAstra?: string | null, libelleAction?: string | null, lien?: string | null, misEnAvant?: boolean | null, nom?: string | null, tauxRemplissage?: number | null, titreEditeur?: string | null, titreGrain?: string | null, url?: string | null, numeroFolio?: string | null, structure?: string | null, ordre?: number | null, completion?: string | null, verouille?: boolean | null, commentaires?: string | null, siteBelinEducation?: boolean | null, minilienEdubelin?: boolean | null, pearltrees?: boolean | null, filename?: string | null, pagesIds?: string | null, miniliens?: Array<{ __typename?: 'object_Minilien', url_courte?: string | null, id?: string | null, url_longue?: string | null, type_minilien?: string | null } | null> | null, ouvrage?: { __typename?: 'object_Ouvrage', id?: string | null, CodeProjet?: string | null, is_reprise?: boolean | null, BaseArticle?: { __typename?: 'object_BaseArticle', id?: string | null, TitreWEB?: string | null, EAN?: string | null, CodeArticle?: string | null, StatutArticle?: string | null, Support?: string | null, NomCollection?: string | null, Matieres?: Array<string | null> | null, Classe?: Array<string | null> | null, DateParution?: string | null, AssistantEdito?: string | null, EditeurInterne?: string | null } | null } | null, pageAtterrissage?: Array<{ __typename?: 'object_PageAtterrissage', titre?: string | null, idPage?: string | null, numeroFolio?: number | null, miniliens?: Array<{ __typename?: 'object_Minilien', url_courte?: string | null, id?: string | null, url_longue?: string | null } | null> | null } | null> | null, format?: { __typename?: 'object_Format', id?: string | null, nom?: string | null, extension?: string | null } | null, medias?: Array<{ __typename?: 'asset', filename?: string | null, id?: string | null } | null> | null } | null } | null> | null } | null };

export type GetRessourceNumeriqueListingByIdsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRessourceNumeriqueListingByIdsQuery = { __typename?: 'Query', getRessourceNumeriqueListing?: { __typename?: 'RessourceNumeriqueConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'RessourceNumeriqueEdge', node?: { __typename?: 'object_RessourceNumerique', id?: string | null, modificationDateFormatted?: string | null, Lib?: boolean | null, LibImpression?: boolean | null, LibModification?: boolean | null, LibTelechargement?: boolean | null, Max?: boolean | null, OGRNPlay?: boolean | null, categorie?: string | null, cible?: string | null, debutVideo?: number | null, finVideo?: number | null, idAstra?: string | null, libelleAction?: string | null, lien?: string | null, misEnAvant?: boolean | null, nom?: string | null, tauxRemplissage?: number | null, titreEditeur?: string | null, titreGrain?: string | null, url?: string | null, numeroFolio?: string | null, structure?: string | null, ordre?: number | null, completion?: string | null, verouille?: boolean | null, commentaires?: string | null, siteBelinEducation?: boolean | null, minilienEdubelin?: boolean | null, pearltrees?: boolean | null, filename?: string | null, pagesIds?: string | null, miniliens?: Array<{ __typename?: 'object_Minilien', url_courte?: string | null, id?: string | null, url_longue?: string | null, type_minilien?: string | null } | null> | null, ouvrage?: { __typename?: 'object_Ouvrage', CodeProjet?: string | null, is_reprise?: boolean | null, BaseArticle?: { __typename?: 'object_BaseArticle', id?: string | null, TitreWEB?: string | null, EAN?: string | null, CodeArticle?: string | null, StatutArticle?: string | null, Support?: string | null, NomCollection?: string | null, Matieres?: Array<string | null> | null, Classe?: Array<string | null> | null, DateParution?: string | null, AssistantEdito?: string | null, EditeurInterne?: string | null } | null } | null, pageAtterrissage?: Array<{ __typename?: 'object_PageAtterrissage', titre?: string | null, idPage?: string | null, numeroFolio?: number | null, miniliens?: Array<{ __typename?: 'object_Minilien', url_courte?: string | null, id?: string | null, url_longue?: string | null } | null> | null } | null> | null, format?: { __typename?: 'object_Format', id?: string | null, nom?: string | null, extension?: string | null } | null, medias?: Array<{ __typename?: 'asset', filename?: string | null, id?: string | null } | null> | null } | null } | null> | null } | null };

export type GetUserListingQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserListingQuery = { __typename?: 'Query', getUserListing?: { __typename?: 'UserConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'object_user', id?: string | null, email?: string | null, firstname?: string | null, lastname?: string | null, roles?: Array<string | null> | null } | null } | null> | null } | null };

export const CreateMinilienDocument = gql`
    mutation createMinilien($key: String!, $input: UpdateMinilienInput) {
  createMinilien(path: "/miniliens", key: $key, input: $input) {
    success
    output {
      modificationDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMinilienGQL extends Apollo.Mutation<CreateMinilienMutation, CreateMinilienMutationVariables> {
    override document = CreateMinilienDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMinilienDocument = gql`
    mutation updateMinilien($id: Int, $input: UpdateMinilienInput) {
  updateMinilien(id: $id, input: $input) {
    success
    output {
      modificationDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMinilienGQL extends Apollo.Mutation<UpdateMinilienMutation, UpdateMinilienMutationVariables> {
    override document = UpdateMinilienDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOuvrageDocument = gql`
    mutation updateOuvrage($id: Int, $input: UpdateOuvrageInput) {
  updateOuvrage(id: $id, input: $input) {
    success
    output {
      modificationDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOuvrageGQL extends Apollo.Mutation<UpdateOuvrageMutation, UpdateOuvrageMutationVariables> {
    override document = UpdateOuvrageDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePageAtterrissageDocument = gql`
    mutation updatePageAtterrissage($id: Int, $input: UpdatePageAtterrissageInput) {
  updatePageAtterrissage(id: $id, input: $input) {
    success
    message
    output {
      modificationDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePageAtterrissageGQL extends Apollo.Mutation<UpdatePageAtterrissageMutation, UpdatePageAtterrissageMutationVariables> {
    override document = UpdatePageAtterrissageDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRessourceNumeriqueDocument = gql`
    mutation updateRessourceNumerique($id: Int, $input: UpdateRessourceNumeriqueInput) {
  updateRessourceNumerique(id: $id, input: $input) {
    success
    message
    output {
      modificationDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRessourceNumeriqueGQL extends Apollo.Mutation<UpdateRessourceNumeriqueMutation, UpdateRessourceNumeriqueMutationVariables> {
    override document = UpdateRessourceNumeriqueDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFormatListingDocument = gql`
    query getFormatListing($filter: String) {
  getFormatListing(filter: $filter) {
    totalCount
    edges {
      node {
        id
        nom
        extension
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFormatListingGQL extends Apollo.Query<GetFormatListingQuery, GetFormatListingQueryVariables> {
    override document = GetFormatListingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBaseArticlesListingDocument = gql`
    query getBaseArticlesListing($filter: String) {
  getBaseArticleListing(filter: $filter) {
    totalCount
    edges {
      node {
        id
        CodeArticle
        EAN
        TitreWEB
        ouvrage {
          ... on object_Ouvrage {
            id
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBaseArticlesListingGQL extends Apollo.Query<GetBaseArticlesListingQuery, GetBaseArticlesListingQueryVariables> {
    override document = GetBaseArticlesListingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOuvrageByIdDocument = gql`
    query getOuvrageByID($id: Int) {
  getOuvrage(id: $id) {
    CodeProjet
    statut
    taux_remplissage_rn
    taux_remplissage_media
    ouvrage_reforme
    is_reprise
    BaseArticle {
      ... on object_BaseArticle {
        id
        CodeArticle
        EAN
        CodeOeuvre
        CollectionEdito_search
        DateParution
        Matieres
        Classe
        Support
        StatutArticle
        AssistantEdito
        EditeurInterne
        TitreWEB
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOuvrageByIdGQL extends Apollo.Query<GetOuvrageByIdQuery, GetOuvrageByIdQueryVariables> {
    override document = GetOuvrageByIdDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetIntervenantListingDocument = gql`
    query getIntervenantListing($filter: String, $after: Int, $first: Int) {
  getIntervenantListing(filter: $filter, first: $first, after: $after) {
    totalCount
    edges {
      node {
        id
        code
        display_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIntervenantListingGQL extends Apollo.Query<GetIntervenantListingQuery, GetIntervenantListingQueryVariables> {
    override document = GetIntervenantListingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMinilienListingDocument = gql`
    query getMinilienListing($filter: String, $after: Int, $first: Int) {
  getMinilienListing(
    filter: $filter
    first: $first
    after: $after
    joins: "{\\"RessourceNumerique\\": {\\"table\\" : \\"object_8\\", \\"joinWith\\" : \\"object_9\\", \\"type\\": \\"LEFT\\"}}"
  ) {
    totalCount
    edges {
      node {
        id
        url_courte
        url_longue
        codeArticle
        idPage
        TitreWeb
        type_minilien
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMinilienListingGQL extends Apollo.Query<GetMinilienListingQuery, GetMinilienListingQueryVariables> {
    override document = GetMinilienListingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOuvrageListingDocument = gql`
    query getOuvrageListing($filter: String, $after: Int, $first: Int) {
  getOuvrageListing(
    filter: $filter
    first: $first
    after: $after
    joins: "{\\"BaseArticle\\": {\\"table\\" : \\"object_2\\", \\"joinWith\\" : \\"object_3\\"}}"
  ) {
    totalCount
    edges {
      node {
        id
        taux_remplissage_rn
        taux_remplissage_media
        ouvrage_reforme
        CodeProjet
        BaseArticle {
          ... on object_BaseArticle {
            CodeArticle
            TitreWEB
            EAN
            CodeOeuvre
            StatutArticle
            Support
            CollectionEdito_search
            DateParution
            Matieres
            Classe
            AssistantEdito
            EditeurInterne
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOuvrageListingGQL extends Apollo.Query<GetOuvrageListingQuery, GetOuvrageListingQueryVariables> {
    override document = GetOuvrageListingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPageAtterrissageListingDocument = gql`
    query getPageAtterrissageListing($filter: String, $ids: String) {
  getPageAtterrissageListing(ids: $ids, filter: $filter) {
    totalCount
    edges {
      node {
        id
        idPage
        titre
        numeroFolio
        taux_remplissage_rn
        taux_remplissage_media
        actif
        verouille
        miniliens {
          ... on object_Minilien {
            url_courte
            id
            url_longue
            type_minilien
          }
        }
        ressourcesNumeriques {
          ... on object_RessourceNumerique {
            id
          }
        }
        ouvrage {
          ... on object_Ouvrage {
            id
            CodeProjet
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPageAtterrissageListingGQL extends Apollo.Query<GetPageAtterrissageListingQuery, GetPageAtterrissageListingQueryVariables> {
    override document = GetPageAtterrissageListingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRessourceNumeriqueListingDocument = gql`
    query getRessourceNumeriqueListing($filter: String, $after: Int, $first: Int, $ids: String) {
  getRessourceNumeriqueListing(
    ids: $ids
    filter: $filter
    sortBy: "ordre"
    sortOrder: "ASC"
    first: $first
    after: $after
    joins: "{\\"ouvrage\\": {\\"table\\" : \\"object_3\\", \\"joinWith\\" : \\"object_8\\"}, \\"BaseArticle\\": {\\"table\\" : \\"object_2\\", \\"joinWith\\" : \\"ouvrage\\"}, \\"format\\": {\\"table\\" : \\"object_11\\", \\"joinWith\\" : \\"object_8\\"}}"
  ) {
    totalCount
    edges {
      node {
        id
        modificationDateFormatted
        Lib
        LibImpression
        LibModification
        LibTelechargement
        Max
        OGRNPlay
        categorie
        cible
        debutVideo
        finVideo
        idAstra
        libelleAction
        lien
        misEnAvant
        nom
        tauxRemplissage
        titreEditeur
        titreGrain
        url
        numeroFolio
        structure
        ordre
        completion
        verouille
        commentaires
        siteBelinEducation
        minilienEdubelin
        pearltrees
        filename
        pagesIds
        miniliens {
          ... on object_Minilien {
            url_courte
            id
            url_longue
            type_minilien
          }
        }
        ouvrage {
          ... on object_Ouvrage {
            id
            CodeProjet
            is_reprise
            BaseArticle {
              ... on object_BaseArticle {
                id
                TitreWEB
                EAN
                CodeArticle
                StatutArticle
                Support
                NomCollection
                Matieres
                Classe
                DateParution
                AssistantEdito
                EditeurInterne
              }
            }
          }
        }
        pageAtterrissage {
          ... on object_PageAtterrissage {
            titre
            idPage
            numeroFolio
            miniliens {
              ... on object_Minilien {
                url_courte
                id
                url_longue
              }
            }
          }
        }
        format {
          ... on object_Format {
            id
            nom
            extension
          }
        }
        medias {
          ... on asset {
            filename
            id
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRessourceNumeriqueListingGQL extends Apollo.Query<GetRessourceNumeriqueListingQuery, GetRessourceNumeriqueListingQueryVariables> {
    override document = GetRessourceNumeriqueListingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRessourceNumeriqueListingByIdsDocument = gql`
    query getRessourceNumeriqueListingByIds($filter: String, $after: Int, $first: Int, $ids: String) {
  getRessourceNumeriqueListing(
    ids: $ids
    filter: $filter
    sortBy: "ordre"
    sortOrder: "ASC"
    first: $first
    after: $after
  ) {
    totalCount
    edges {
      node {
        id
        modificationDateFormatted
        Lib
        LibImpression
        LibModification
        LibTelechargement
        Max
        OGRNPlay
        categorie
        cible
        debutVideo
        finVideo
        idAstra
        libelleAction
        lien
        misEnAvant
        nom
        tauxRemplissage
        titreEditeur
        titreGrain
        url
        numeroFolio
        structure
        ordre
        completion
        verouille
        commentaires
        siteBelinEducation
        minilienEdubelin
        pearltrees
        filename
        pagesIds
        miniliens {
          ... on object_Minilien {
            url_courte
            id
            url_longue
            type_minilien
          }
        }
        ouvrage {
          ... on object_Ouvrage {
            CodeProjet
            is_reprise
            BaseArticle {
              ... on object_BaseArticle {
                id
                TitreWEB
                EAN
                CodeArticle
                StatutArticle
                Support
                NomCollection
                Matieres
                Classe
                DateParution
                AssistantEdito
                EditeurInterne
              }
            }
          }
        }
        pageAtterrissage {
          ... on object_PageAtterrissage {
            titre
            idPage
            numeroFolio
            miniliens {
              ... on object_Minilien {
                url_courte
                id
                url_longue
              }
            }
          }
        }
        format {
          ... on object_Format {
            id
            nom
            extension
          }
        }
        medias {
          ... on asset {
            filename
            id
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRessourceNumeriqueListingByIdsGQL extends Apollo.Query<GetRessourceNumeriqueListingByIdsQuery, GetRessourceNumeriqueListingByIdsQueryVariables> {
    override document = GetRessourceNumeriqueListingByIdsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserListingDocument = gql`
    query getUserListing($filter: String) {
  getUserListing(filter: $filter) {
    totalCount
    edges {
      node {
        id
        email
        firstname
        lastname
        roles
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserListingGQL extends Apollo.Query<GetUserListingQuery, GetUserListingQueryVariables> {
    override document = GetUserListingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
